import styled from "styled-components";

const ITStyle = {
  GuideDiv: styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    background-color: #fff;
    & + & {
      margin-top: 8px;
    }

    & > p {
      ${({ theme }) => theme.font.extra_small};
      color: ${({ theme }) => theme.color.grey4};
    }
  `,
  TableDiv: styled.div`
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid ${({ theme }) => theme.color.grey2};
  `,
  TableElement: styled.div`
    flex-basis: 50%;
    flex-grow: 1;
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

    & > h2 {
      display: flex;
      align-items: center;
      width: 200px;
      min-width: 200px;
      padding: 8px 16px;
      background-color: ${({ theme }) => theme.color.grey1};
      ${({ theme }) => theme.font.extra_small_bold};

      & > span {
        ${({ theme }) => theme.font.extra_small_bold};
        color: ${({ theme }) => theme.color.major};
      }
    }

    & > .upload-image-container {
      width: 100%;
      background-color: white;
      padding: 8px 16px;
      margin: 6px 6px;
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 6px;
      height: 250px;
    }

    & > input {
      padding: 8px 16px;
      margin: 6px 6px;
      flex-grow: 1;
      ${({ theme }) => theme.font.extra_small};
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;
    }

    & > textarea {
      height: 200px;
      flex-grow: 1;
      ${({ theme }) => theme.font.extra_small};
      padding: 8px 16px;
      margin: 6px 6px;
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;
    }

    & > select {
      width: 100%;
      padding: 8px 16px;
      margin: 6px 6px;
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;
    }
  `,
  TableVerticalElement: styled.div`
    width: 100%;
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

    & > h2 {
      display: flex;
      align-items: center;
      width: 200px;
      min-width: 200px;
      padding: 8px 16px;
      background-color: ${({ theme }) => theme.color.grey1};
      ${({ theme }) => theme.font.extra_small_bold};

      & > span {
        ${({ theme }) => theme.font.extra_small_bold};
        color: ${({ theme }) => theme.color.major};
      }
    }

    & > input {
      width: 100%;
      padding: 8px 16px;
      margin: 6px 6px;
      ${({ theme }) => theme.font.extra_small};
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;
    }

    & > textarea {
      height: 200px;
      flex-grow: 1;
      ${({ theme }) => theme.font.extra_small};
      padding: 8px 16px;
      margin: 6px 6px;
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;
    }
  `,
};

export default ITStyle;
